import { Loader } from '@fable/components'
import { css } from '@fable/theme'
import { useQuery } from 'react-query'
import { authWithCustomToken, getCustomToken } from './helpers'

interface Props {
  children: React.ReactNode | React.ReactNode[]
  token: string
}

export const MagicAuthHandler = ({ children, token }: Props) => {
  const tokenQuery = useQuery(
    ['custom_token', token],
    () => getCustomToken(token),
    { enabled: !!token }
  )

  const customToken = tokenQuery?.data?.data?.custom_token

  const signInQuery = useQuery(
    ['token_sign_in'],
    () => authWithCustomToken(customToken),
    {
      enabled: !!customToken,
    }
  )

  if (signInQuery.isFetching || tokenQuery.isFetching) {
    return (
      <Loader
        className={css`
          height: 100vh;
        `}
      />
    )
  }

  return <>{children}</>
}
